import { cx } from 'cva';
import { type FunctionComponent } from 'react';
import { useTranslation } from '../../../../i18n/resources';
import {
  BUILD_DATE,
  COMMIT_HASH,
  PACKAGE_VERSION,
} from '../../../../vite/version';
import styles from './FooterVersion.module.css';

export type FooterVersionProps = {
  className?: string;
};

export const FooterVersion: FunctionComponent<FooterVersionProps> = ({
  className,
}) => {
  const { t } = useTranslation();

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.container}>
        <div className={styles.links}>
          <a
            className={styles.link}
            href="https://www.medishare.com/utility/internet-privacy/"
          >
            {t('footer', 'menu_privacy_policy')}
          </a>
          <a
            className={styles.link}
            href="https://mychristiancare.org/utility/website-terms-of-use/"
          >
            {t('footer', 'menu_terms_of_use')}
          </a>
        </div>
        <div className={styles.version} data-chromatic="ignore">
          <div className={styles.desktop}>
            {`${t('footer', 'version')}: ${PACKAGE_VERSION} - ${COMMIT_HASH} - ${BUILD_DATE}`}
          </div>
          <div className={styles.mobile}>
            <div>{`${t('footer', 'version')}: ${PACKAGE_VERSION} - ${COMMIT_HASH}`}</div>
            <div>{BUILD_DATE}</div>
          </div>
        </div>
        <div data-chromatic="ignore">{t('footer', 'copyright')}</div>
      </div>
    </div>
  );
};
